import { PublicLayout } from "@/components/PublicLayout";
import { useSeo } from "@/lib/useSeo";
import { Check } from "lucide-react";

export function ServicePage({ hero, eyebrow, title, intro, image, services, keywords, seoTitle, seoDesc, canonical, children }) {
  useSeo({ title: seoTitle, description: seoDesc, canonicalPath: canonical });
  return (
    <PublicLayout>
      <section className="relative bg-[#1B2A41] overflow-hidden">
        {image && <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover opacity-25" />}
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-20">
          <p className="eyebrow text-[#F5A623]">{eyebrow}</p>
          <h1 className="font-display text-4xl lg:text-5xl font-bold text-white mt-3 max-w-3xl leading-tight">{title}</h1>
          <p className="text-lg text-white/80 mt-5 max-w-2xl leading-relaxed">{intro}</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((sv, i) => (
            <div key={i} className="bg-white rounded-2xl p-7 border border-[#DCE6EF]" data-testid={`service-${i}`}>
              <div className="w-11 h-11 rounded-xl bg-[#EEF4F9] flex items-center justify-center text-[#2472C8]"><Check className="w-5 h-5" strokeWidth={2.5} /></div>
              <h3 className="font-heading text-lg font-semibold text-[#1B2A41] mt-4">{sv.title}</h3>
              <p className="text-[#566476] mt-2 leading-relaxed text-[15px]">{sv.text}</p>
            </div>
          ))}
        </div>
        {keywords && (
          <div className="mt-12 flex flex-wrap gap-2">
            {keywords.map((k) => <span key={k} className="text-xs font-mono bg-[#E3ECF3] text-[#566476] px-3 py-1.5 rounded-full">{k}</span>)}
          </div>
        )}
      </section>
      {children}
    </PublicLayout>
  );
}
